module.exports = __webpack_public_path__ + "static/media/tube.c3278053.svg";